import { generateUrl } from 'utils/helpers';

import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

export const hospitalList = () =>
  apiLoaderInstance.get(URL.GET_BITWERX_HOSPITAL_LIST);

export const getAppointmentReasons = (hospitalId: number) =>
  apiLoaderInstance.get(
    generateUrl(URL.GET_BITWERX_APPOINTMENT_REASONS, { id: hospitalId })
  );

export const getRooms = (hospitalId: number) =>
  apiLoaderInstance.get(
    generateUrl(URL.GET_BITWERX_ROOM_MASTER_LIST, { id: hospitalId })
  );
